import { RouteRecordRaw } from 'vue-router';
import { ViewTrainingPage } from '@/pages/training';

export const routeName = 'TreinamentosVisualizar';

export const route: RouteRecordRaw = {
  path: 'treinamentos/lista-treinamentos/:id',
  name: routeName,
  component: ViewTrainingPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Visualizar Treinamento',
    dynamicBreadcrumb: true,
    permissions: [{ action: 'read', subject: 'Training' }],
  },
};
